import React from "react";
import { useTranslation } from 'react-i18next';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';


export const ProviderSelector = ({ providers, selectedProvider, handleSelectedProvider, width }) => {

    const { t } = useTranslation();
    const label = t("Weather.provider");

    return (
        <Autocomplete
            id="combo-box-demo"
            value={selectedProvider}
            onChange={handleSelectedProvider}
            options={providers}
            getOptionLabel={(option) => (option.name)}
            fullWidth
            disableClearable
            renderInput={(params) => <TextField {...params} label={label} size="small" />}
        />)
}